import {
  LIBRARY_ASSETS_ORIGIN_URL,
  LIBRARY_ASSETS_LOCAL_URL,
  DEVICE, IDENTITY_KEY_NAME,
} from '../constants';
import getValueByGlobalUser from './globalUser';
import getValueByStorageKey from './lockr';
import { parseAppVersionToNumber } from './tools';

export const nativeFunction = {
  NOT_EXIST: 'notExist',
  GET_IDENTITY: 'getIdentity', // ios与安卓统一的获取个人信息的方法，不需要传任何数据
  CHECK_LOCAL_DATA: 'checkLocalData',
  USE_NATIVE_POST: 'postByNative',
  DOWNLOAD_BOOK: 'downloadBook',
  START_TEST_PRONOUNCE: 'speechUnderstand',
  STOP_TEST_PRONOUNCE: 'stopSpeechUnderstand',
  CANCEL_TEST_PRONOUNCE: 'cancelSpeechUnderstand', // 已废弃
  TO_SHARE: 'toShare',
  BACK: 'back',
  PLAY_LOCAL_AUDIO: 'playNativeAudio', // 移动端播放ogg格式音频
  STOP_LOCAL_ALL: 'stopNativeAll', // 停止本地所有在播放的东西
  TOAST: 'toast',
  ENTRANCE_BOOK: 'entranceBook',
  START_LOADING: 'startLoading',
  STOP_LOADING: 'stopLoading',
  CHECK_LOCAL_SOUNDS: 'checkLocalSounds',
  REMOVE_CURRENT_BOOK_RESOURCE: 'removeCurrentBookResource',
  LOGOUT: 'logout',
};

export const nativeFunctionParamsConstant = {
  AUDIO: 'AUDIO',
  RECORD: 'RECORD',
  EXERCISE: 'EXERCISE',
  FLIP: 'FLIP',
  SOUNDS: 'SOUNDS',
};

export const osDetect = () => { // 判断属于什么设备
  const { userAgent: u } = navigator;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; // android终端或者uc浏览器
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf('iPad') > -1 || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // ios终端
  if (isAndroid) {
    return DEVICE.ANDROID;
  }
  if (isiOS) {
    return DEVICE.IOS;
  }
  return DEVICE.OTHER;
};

export const callNativeFunction = functionName => (
  (osDetect() === DEVICE.IOS)
    ? (data = {}) => {
      console.log(
        'callNativeFunction',
        functionName, window.webkit.messageHandlers[functionName],
      );
      return (window.webkit && window.webkit.messageHandlers[functionName])
      // window.webkit.messageHandlers是与ios原生交互的固定写法，如果有，则调用functionName方法名
        ? window.webkit.messageHandlers[functionName].postMessage(data)
        : '{ "error": "未处在手机环境" }';
    }
    : (data = {}) => (
      (window.android && window.android[functionName])
      // window.android是与安卓原生交互的固定写法，如果有，则调用functionName方法名
        ? window.android[functionName](JSON.stringify(data))
        : '{ "error": "未处在手机环境" }'
    )
);

const getAndroidIdentity = () => JSON.parse( // 获得安卓返回的信息
  // 调callNativeFunction(nativeFunction.GET_IDENTITY)()安卓方法，nativeFunction.GET_IDENTITY方法名 ()为参数为空
  callNativeFunction(nativeFunction.GET_IDENTITY)() || '{}',
);

const getGlobalUserInfo = (keyName, defaultValue = '') => {
  console.log('iOS getGlobalUserInfo', keyName, window.GLOBAL_USERINFO);
  return (
    window.GLOBAL_USERINFO
      ? getValueByGlobalUser[keyName]()
      : defaultValue
  );
};
const getLocalStorageInfo = (keyName, defaultValue = '') => {
  const value = getValueByStorageKey[keyName]();
  return value !== undefined ? value : defaultValue;
};

// 调取GET_IDENTITY方法后，原生会返回一些信息，如版本号，token等信息，keyName为你想了解的属性
const compatDifferentVersion = (keyName, defaultValue) => {
  const androidReturnValue = getAndroidIdentity()[keyName]; // 获取安卓返回的某个属性的属性值
  // 有0，所以要 !== undefined
  return androidReturnValue !== undefined
    ? androidReturnValue
    : getGlobalUserInfo(keyName, defaultValue);
};

export const getIdentity = (keyName, defaultValue) => {
  if (osDetect() === DEVICE.ANDROID) { // 如果是安卓机器，则从安卓返回的个人信息拿，如果不是，则从localstorage里拿
    return compatDifferentVersion(keyName);
  }

  // console.log('osDetect', osDetect());
  if (osDetect() === DEVICE.IOS) {
    return getGlobalUserInfo(keyName, defaultValue);
  }

  return getLocalStorageInfo(keyName, defaultValue);
};

// 获取版本信息，parseAppVersionToNumber是为版本转化格式
export const getAppVersion = () => {
  const version = getIdentity(IDENTITY_KEY_NAME.APP_VERSION, undefined);
  return parseAppVersionToNumber(version);
};

const detectByUA = () => {
  const { userAgent: u } = navigator;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  const isiOS = u.indexOf('iPhone') > -1;
  const isiPad = u.indexOf('iPad') > -1 || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isAndroid || isiOS) {
    return DEVICE.MOBILE;
  }
  if (isiPad) {
    return DEVICE.PAD;
  }
  return DEVICE.PC;
};

const detectDevice = () => detectByUA();

export const OS = {
  TYPE: detectByUA(), // 设备类型
  URL_HOST: () => (OS.TYPE === DEVICE.PC ? LIBRARY_ASSETS_ORIGIN_URL : LIBRARY_ASSETS_LOCAL_URL),
};

export const getOs = () => { // 如果是学生端按pad处理，不是学生端且不是pc按手机处理
  const uaOs = OS.TYPE;
  const isStudent = getIdentity(IDENTITY_KEY_NAME.APP_NAME) === 'STUDENT';
  if (!isStudent) {
    return uaOs !== DEVICE.PC ? DEVICE.MOBILE : uaOs;
  }
  return DEVICE.PAD;
};

export default detectDevice;
